import { ref } from 'vue'
import PDFObject from 'pdfobject'
import { CV_CONFIG, getCSRFToken } from '../config/cvConfig.js'

export function usePdfPreviewGeneration() {
  const isPdfGenerating = ref(false)
  const pdfError = ref(null)

  const generatePdfPreview = async (cvData) => {
    try {
      isPdfGenerating.value = true
      pdfError.value = null

      const response = await fetch(CV_CONFIG.api.generatePdf, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf',
          'X-CSRF-Token': getCSRFToken()
        },
        body: JSON.stringify(cvData)
      })

      if (!response.ok) {
        throw new Error(`Server returned ${response.status}`)
      }

      const pdfBlob = await response.blob()
      const pdfUrl = URL.createObjectURL(pdfBlob)

      return {
        type: 'pdf',
        url: pdfUrl,
        blob: pdfBlob,
        pageCount: 1
      }
    } catch (error) {
      console.error('PDF preview failed:', error)
      pdfError.value = `PDF preview failed: ${error.message}`
      return null
    } finally {
      isPdfGenerating.value = false
    }
  }

  // Embed PDF using PDFObject into a container
  const embedPdfIntoContainer = (containerElement, pdfUrl, options = {}) => {
    try {
      containerElement.innerHTML = ''

      const pdfOptions = {
        height: '102%',
        width: '102%',
        page: '1',
        pdfOpenParams: {
          view: 'FitH',
          pagemode: 'none',
          toolbar: '0',
          statusbar: '0',
          messages: '0',
          navpanes: '0',
          scrollbar: '1'
        },
        fallbackLink: false,
        PDFJS_URL: false,
        ...options
      }

      const success = PDFObject.embed(pdfUrl, containerElement, pdfOptions)

      if (success) {
        setTimeout(() => {
          const embedElement = containerElement.querySelector('embed, object, iframe')
          if (embedElement) {
            embedElement.style.cssText += `
              width: 104% !important;
              height: 112% !important;
              position: absolute !important;
              top: -6% !important;
              left: -2% !important;
              transform: none !important;
              border: none !important;
              outline: none !important;
              margin: 0 !important;
              padding: 0 !important;
              background: white !important;
              z-index: 1 !important;
            `
          }
        }, 100)

        containerElement.style.cssText += `
          position: relative !important;
          background: white !important;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          overflow: hidden !important;
          border-radius: 14px !important;
        `

        return true
      } else {
        containerElement.innerHTML = `
          <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;background:white;color:#6c757d;text-align:center;padding:40px;">
            <p>PDF preview is not supported in this browser.</p>
            <a href="${pdfUrl}" target="_blank" style="margin-top:16px;padding:10px 20px;background:#000537;color:white;text-decoration:none;border-radius:8px;">Open PDF</a>
          </div>
        `
        return false
      }
    } catch (error) {
      console.error('Error embedding PDF:', error)
      return false
    }
  }

  const cleanupPdfUrl = (url) => {
    if (url && url.startsWith('blob:')) {
      URL.revokeObjectURL(url)
    }
  }

  return {
    isPdfGenerating,
    pdfError,
    generatePdfPreview,
    embedPdfIntoContainer,
    cleanupPdfUrl
  }
}
